import React, { useEffect, useState } from 'react';
//import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
    Typography,
    CircularProgress,
    Card,
    FormControl,
    Box,
    InputLabel,
    MenuItem,
    Select,
    Button,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import TimeBlocsGrid from './TimeBlocsGrid';
import Form from './Form';
import { useTranslation } from 'react-i18next';
import { PresenceValue, relationEventTypeEnum, TimeData, UserData, eventTypeEnum, virtualTypeEnum } from '../types';
import { Controller, useForm } from 'react-hook-form';
import EventPage from './EventPage';

const CenteredContainer = styled('div')({
    margin: 'auto',
    marginTop: '100px',
});

const LoaderTitle = styled(Typography)({
    marginTop: 10,
    fontSize: 14
});

const MyCard = styled(Card)({
    padding: 20,
    backgroundColor: '#C9E3FB'
});

const MyForm = styled(Box)({
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px auto',
});

const FormTitle = styled(Typography)({
    marginTop: '100px',
    fontSize: 18,
});

const MyInputLabel = styled(InputLabel)({
    height: 40,
    backgroundColor: '#FFFFF',
});

const MySelect = styled(Select)({
    width: 300,
    marginBottom: 25,
});

const Submit = styled(Button)({
    marginTop: '20px',
});

interface RecurrencePageProps {
    eventType?: string,
    selectedTime: string;
    availabilitiesData: any,
    activeTimeIndex: any;
    appLanguage: string;
    onSubmitEventForm: (userData: UserData) => void;
    isLoading: boolean;
    errorMessage: boolean;
    handleSelectTime: (timeData: TimeData, index: any) => void;
    handleSelectDate: (dateValue: [], index: any) => void;
    selectedDate: any[],
    activeDateIndex: any;
    handleSubmitPresenceType: (event: any) => void;
    handleSubmitVirtualType: (event: any) => void;
    handleSubmitRecurrenceNbre: (event: any) => void;
    meetingPresenceType: string;
    meetingVirtualType: string;
    nbreRecurrence: string;
    recParam: string;
    onSubmit: () => void,
    submitEventLoading: boolean;
}

const RecurrencePage: React.FC<RecurrencePageProps> = ({
    eventType,
    selectedTime,
    availabilitiesData,
    activeTimeIndex,
    appLanguage,
    onSubmitEventForm,
    isLoading,
    errorMessage,
    handleSelectTime,
    handleSelectDate,
    selectedDate,
    activeDateIndex,
    handleSubmitPresenceType,
    handleSubmitVirtualType,
    handleSubmitRecurrenceNbre,
    meetingPresenceType,
    meetingVirtualType,
    nbreRecurrence,
    recParam,
    onSubmit,
    submitEventLoading
}) => {
    const { t } = useTranslation();
    const {
        handleSubmit,
        control,
        formState: { isSubmitSuccessful },
    } = useForm<PresenceValue>();
    useEffect(() => {
		if (eventType === eventTypeEnum.Portal && recParam !== '' && Number(recParam)<=20 && Number(recParam) > 1) {
			handleSubmit(onSubmit)();
		}
	}, [eventType,nbreRecurrence]);

    const disableButton =  Number(nbreRecurrence)<=20 && Number(nbreRecurrence) > 1 ? true:false;
    const relationEventTypeList = [/* relationEventTypeEnum.Presential, */ relationEventTypeEnum.Virtual];
    const virtualTypeList = [virtualTypeEnum.Phone, virtualTypeEnum.Zoom];
    //Setting number of recurrence values
    const numberList = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    let infoMessage: string;
    let needsAssistanceLink = false;

    switch (eventType) {
        case eventTypeEnum.Service:
        case eventTypeEnum.Introduction:
        case eventTypeEnum.Portal:
            infoMessage = t('info_leo');
            break;
        default:
            infoMessage = t('info');
            needsAssistanceLink = true;
    }

    const renderInfoMessage = () => {
        if (isLoading) return null;

        return (
            <p>
                {infoMessage}{` `}
                {needsAssistanceLink && <a href={t('url_needAssistance')} target='_BLANK' rel="noreferrer">{t('here')}</a>}
            </p>
        );
    };

    const renderRecurrencePage = () => {
        console.log('nbreRecurrence ',nbreRecurrence);
        if (!isSubmitSuccessful && (eventType === eventTypeEnum.Portal)) {
            return (
                <form onSubmit={handleSubmit(onSubmit)}>
					<FormTitle>{t('recurrenceNbreLabel')}</FormTitle>
                    <MyForm>
                        <Controller
                            control={control}
                            name="nbreRecurrence"
                            render={({ field }) => (
                                <FormControl>
                                    <MyInputLabel id="nbreRecurrence">{t('recurrenceNbreLabel')}</MyInputLabel>
                                    <MySelect
                                        {...field}
                                        label={t('recurrenceNbreLabel')}
                                        labelId="nbreRecurrence"
                                        onChange={handleSubmitRecurrenceNbre}
                                        defaultValue={nbreRecurrence || ''}
                                    >
                                        {numberList.map((value) => (
                                            <MenuItem key={value} value={value}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </MySelect>
                                </FormControl>
                            )}
                        />
                        <Submit
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={!disableButton}
                        >
                            {t('next')}
                        </Submit>
                    </MyForm>
                </form>
            );
        } else {
            return (
                <EventPage
                    selectedDate={selectedDate}
                    activeDateIndex={activeDateIndex}
                    handleSelectDate={handleSelectDate}
                    availabilitiesData={availabilitiesData}
                    errorMessage={errorMessage}
                    isLoading={isLoading}
                    handleSelectTime={handleSelectTime}
                    activeTimeIndex={activeTimeIndex}
                    appLanguage={appLanguage}
                    eventType={eventType}
                    onSubmitEventForm={onSubmitEventForm}
                    selectedTime={selectedTime}
                    handleSubmitPresenceType={handleSubmitPresenceType}
                    handleSubmitVirtualType={handleSubmitVirtualType}
                    meetingPresenceType={meetingPresenceType}
                    meetingVirtualType={meetingVirtualType}
                    
                    onSubmit={onSubmit}
                    submitEventLoading={submitEventLoading}
                />
            );
        }
    };

    return (
        <>
             {isLoading ? (
                <CenteredContainer>
                    
                </CenteredContainer>
            ) : (
                <>
                    
                </>
            )}
            {renderRecurrencePage()}
        </>
    );
};

export default RecurrencePage;
